module.exports = __webpack_public_path__ + "img/mushroom-and-lentil-soup.0762696f.jpg";